
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune2",
      function () {
        return require("private-next-pages/money-fortune2/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune2"])
      });
    }
  